import React, {useEffect, useState} from 'react';
import './NotEnoughCrystalsModal.css';
import PageButton from '../../../elements/PageButton/PageButton';
import {getFormattedPrice} from '../../../../utils/price/getFormattedPrice';
import {PRIMARY_COLOR} from '../../../../styles/constants';

const PAGE_ID = 'NotEnoughCrystalsModal';

/**
 * «Недостаточно кристаллов» при покупке сундука/фракции в магазине: сколько
 * не хватает + кнопка перехода во вкладку покупки кристаллов. Рисуется ПОВЕРХ
 * модалки покупки сундука (z-index выше chest-purchase-overlay).
 * warningText — опциональное предупреждение над кнопкой перехода: карусель
 * выбора фракции открывается и внутри активного сетевого лобби/локальной
 * настройки игроков, где переход в магазин — не бесплатное действие (выход
 * из лобби / сброс несохранённого прогресса), в отличие от самого магазина
 */
function NotEnoughCrystalsModal({missingAmount, onGoToCrystals, onClose, warningText}) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const showTimer = setTimeout(() => setVisible(true), 50);
    return () => clearTimeout(showTimer);
  }, []);

  const handleClose = () => {
    setVisible(false);
    setTimeout(() => {
      onClose?.();
    }, 300);
  };

  const handleOverlayClick = (event) => {
    if (event.target === event.currentTarget) {
      handleClose();
    }
  };

  const handleGoToCrystals = () => {
    setVisible(false);
    setTimeout(() => {
      onGoToCrystals?.();
    }, 300);
  };

  return (
    <div
      className={`not-enough-crystals-overlay ${visible ? 'not-enough-crystals-overlay_visible' : ''}`}
      onClick={handleOverlayClick}
      role="dialog"
      aria-modal="true"
    >
      <div className={`not-enough-crystals-modal ${visible ? 'not-enough-crystals-modal_visible' : ''}`}>
        <img
          className="not-enough-crystals-icon"
          src="/img/icons/crystal.png"
          alt="Кристаллы"
        />

        <h2 className="not-enough-crystals-title">Недостаточно кристаллов</h2>

        <p className="not-enough-crystals-text">
          Для покупки не хватает{' '}
          <span className="not-enough-crystals-missing text-crystals">
            {getFormattedPrice(missingAmount)}
            <img
              className="not-enough-crystals-missing-icon"
              src="/img/icons/crystal.png"
              alt="Кристаллы"
            />
          </span>
        </p>

        {warningText && (
          <p className="not-enough-crystals-warning">{warningText}</p>
        )}

        <div className="main-menu-buttons not-enough-crystals-buttons">
          <PageButton
            className="not-enough-crystals-go-button"
            onClick={handleGoToCrystals}
            pageId={PAGE_ID}
            buttonId="go_to_crystals"
            style={{backgroundColor: PRIMARY_COLOR}}
          >
            За кристаллами
          </PageButton>

          <PageButton
            className="main-menu-button_secondary"
            onClick={handleClose}
            pageId={PAGE_ID}
            buttonId="hide"
          >
            Скрыть
          </PageButton>
        </div>
      </div>
    </div>
  );
}

export default NotEnoughCrystalsModal;
